import { createStaffPrivacyApi, type PrivacyExportFile } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { PrivacyRuntime } from "./runtime";

/** A browser download of the file: a Blob in memory, an anchor click, and the Blob is released at once. Nothing is stored or put in a URL. */
function saveFileInBrowser(file: PrivacyExportFile): void {
  const url = URL.createObjectURL(new Blob([file.content], { type: "application/json" }));
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = file.filename;
    anchor.rel = "noopener";
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** The runtime of the real admin app: the typed client over `fetch`, the clock and the browser download. */
export function createAdminPrivacyRuntime(): PrivacyRuntime {
  const config = getAdminPublicConfig();
  return {
    api: createStaffPrivacyApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    now: () => new Date(),
    saveFile: saveFileInBrowser,
  };
}
